<!-- 收银台 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <el-card class="box-card">
      <div class="pay-message">
        <div class="pay-message-top">
          <div>
            <p>
              订单提交成功请尽快付款！订单号：{{ orderInfo.osn }}
              <span
                v-if="orderInfo.orderState != 20"
                class="payState-dir"
              >
                {{
                orderInfo.stateMsg
                }}
              </span>
            </p>
            <p class="payLimit">
              请您在
              <span class="color-red">24小时内</span>完成支付，否则订单会被自动取消
            </p>
          </div>
          <div style="text-align: right">
            <p>
              应付款：
              <span style="color: red;font-weight: bold">
                {{
                orderInfo.surplusMoney
                }}
              </span>元
            </p>
            <p class="showMsg" @click="showMsg">
              <i class="el-icon-caret-bottom"></i>
              订单详情
            </p>
          </div>
        </div>
        <div class="pay-message-bottom" v-if="showOrderMsg">
          <div>
            <span>收货地址：{{ orderInfo.shipAddr }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span>
              收货人：{{ orderInfo.consignee }} &nbsp;&nbsp;&nbsp;&nbsp;{{
              orderInfo.phone
              }}
            </span>
          </div>
          <div>
            商品名称：
            <span
              :key="index"
              class="goods-item"
              v-for="(item,index) in orderInfo.goodsNames"
            >{{ item }}</span>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card pay-way-ctn">
      <div slot="header">
        <span class="pay-way-header">车回佳收银台</span>
      </div>
      <div class="pay-way">
        <div
          class="pay-item"
          :class="{ 'pay-item-active': payWay == 0 }"
          @click="unionpayPay"
          v-if="payWayPbj.unionPay"
        >
          <img src="../../../assets/images/yinlian.png" alt />
          <span>中国银联</span>
        </div>
        <div
          class="pay-item"
          :class="{ 'pay-item-active': payWay == 1 }"
          @click="wechatPay"
          v-if="payWayPbj.wechatPay"
        >
          <img src="../../../assets/images/wechatPay.png" alt />
          <span>微信支付</span>
        </div>
        <div
          class="pay-item"
          :class="{ 'pay-item-active': payWay == 2 }"
          @click="aliPay"
          v-if="payWayPbj.aliPay"
        >
          <img src="../../../assets/images/alipay.png" alt />
          <span>支付宝</span>
        </div>
      </div>
    </el-card>
    <div class="pay-btn-ctn">
      <el-button
        class="pay-btn btn-primary"
        @click="pay"
        v-if="orderInfo.orderState == 20 && permission.payMoney"
      >{{ permission.payMoney }}</el-button>
    </div>
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px">
      <div class="dialog-content">
        <div class="dialog-content-dir">
          <p>请在第三方支付页面完成付款</p>
          <p>付款完成前请不要关闭此窗口</p>
        </div>
        <div style="text-align: right">
          <el-button class="pay-btn btn-primary" @click="gotoShopOrder">我已付款成功</el-button>
          <el-button class="pay-btn" @click="reLoadPage" style="width: 200px">付款遇到问题重新支付</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: { breadcrumb },
  data() {
    return {
      dialogVisible: false,
      payWayPbj: {
        unionPay: false,
        aliPay: false,
        wechatPay: false
      },
      payWay: 1,
      showOrderMsg: false,
      osn: "",
      orderInfo: {},
      permission: {}
    };
  },
  mounted() {
    this.osn = this.$route.query.osn;
    this.permission = this.$util.getPermission("ShopOrder");
    this.getData();
  },
  methods: {
    reLoadPage() {
      window.location.reload();
    },
    gotoShopOrder() {
      this.$router.push(`./shopOrder`);
    },
    getData() {
      this.$util
        .axiosGet({
          url: "/api/Pay/GetPayPageInfo",
          data: {
            osn: this.osn
          },
          exception: true
        })
        .then(res => {
          if (res.errcode == 500) {
            this.$util.warningMsg(res.errmsg);
            setTimeout(() => {
              this.$router.push(`./orderDetails?orderId=${res.data.oid}`);
            }, 2000);
          } else {
            let data = res.data;
            for (let i = 0; i < data.payWay.length; i++) {
              if (data.payWay[i].Value == "支付宝") {
                this.payWayPbj.aliPay = true;
              }
              if (data.payWay[i].Value == "微信") {
                this.payWayPbj.wechatPay = true;
              }
              if (data.payWay[i].Value == "中国银联") {
                this.payWayPbj.unionPay = true;
              }
            }
            this.orderInfo = data;
          }
        });
    },
    showMsg() {
      this.showOrderMsg = !this.showOrderMsg;
    },
    pay() {
      if (this.payWay == 0) {
        // this.$util.successMsg("支付成功！")
      } else if (this.payWay == 1) {
        this.$router.push(`./payWechat?osn=${this.osn}`);
      } else if (this.payWay == 2) {
        this.$util
          .axiosPost({
            url: `/api/Pay/AliPayRequest?osn=${this.osn}&uid=${
              this.$util.getLocalStorage("userMsg").EmployeeId
            }`
          })
          .then(res => {
            this.dialogVisible = true;
            window.open(res.data);
            // window.location.href = res.data;
          });
      }
    },
    // 银联支付
    unionpayPay() {
      this.payWay = 0;
    },
    // 微信支付
    wechatPay() {
      this.payWay = 1;
    },
    // 支付宝
    aliPay() {
      this.payWay = 2;
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content-dir {
  padding-left: 50px;
  margin-bottom: 20px;
  font-size: @font-sm;
  line-height: 2em;
}
.payState-dir {
  color: red;
  font-size: @font-md;
  margin-left: 20px;
}
.payLimit {
  font-size: 14px;
  color: #909399;
  padding-top: 10px;
}
.showMsg {
  font-size: @font-xs;
  cursor: pointer;
  margin-top: 10px;
  color: @theme;
}
.pay-btn-ctn {
  text-align: right;
}
.pay-btn {
  width: 150px;
}
.pay-item-active {
  border: 2px solid @theme;
  background: rgb(255, 252, 236);
}
.pay-way-header {
  font-size: @font-md;
}
.pay-way-ctn {
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 10px;
}
.pay-way {
  padding: 30px 10px;
  display: flex;
}
.pay-item {
  width: 150px;
  height: 60px;
  cursor: pointer;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 30px;
    width: auto;
    margin-right: 10px;
  }
}
.pay-message {
  padding: 10px;
  font-size: @font-sm;
  line-height: 1.5em;
}
.pay-message-top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
.pay-message-bottom {
  border-top: 1px solid @border3Color;
  padding-top: 20px;
  font-size: @font-xs;
  color: #909399;
}
.goods-item {
  margin-right: 10px;
  margin-bottom: 20px;
}
</style>
